export const quiz=[
    {
      "question": "¿Qué son las criptomonedas?",
      "options": [
        "Formas de dinero digital descentralizado que utilizan criptografía para asegurar transacciones.",
        "Dinero físico emitido por bancos centrales.",
        "Acciones en el mercado bursátil.",
        "Monedas tradicionales respaldadas por gobiernos."
      ],
      "answer": 0
    },
    {
      "question": "¿Cuál es una característica principal de la tecnología blockchain?",
      "options": [
        "Centralización de la información en un solo servidor.",
        "Inmutabilidad y descentralización de los datos registrados.",
        "Eliminación de la necesidad de computadoras en la red.",
        "Control exclusivo por una autoridad central."
      ],
      "answer": 1
    },
    {
      "question": "¿Qué diferencia fundamental existe entre criptomonedas y tokens?",
      "options": [
        "Las criptomonedas son digitales y los tokens no.",
        "Las criptomonedas tienen su propia blockchain, los tokens se emiten en blockchains existentes.",
        "Los tokens son siempre más seguros que las criptomonedas.",
        "Los tokens solo pueden usarse para pagos internacionales."
      ],
      "answer": 1
    },
    {
      "question": "¿Cuál de las siguientes es una criptomoneda conocida por ser la primera creada?",
      "options": [
        "Ethereum",
        "Bitcoin",
        "Ripple",
        "Litecoin"
      ],
      "answer": 1
    },
    {
      "question": "¿Para qué se utilizan los contratos inteligentes en blockchain?",
      "options": [
        "Para ejecutar automáticamente acuerdos entre partes según reglas predefinidas.",
        "Para emitir moneda física respaldada por oro.",
        "Para centralizar el control de las transacciones financieras.",
        "Para eliminar completamente la necesidad de nodos en la red."
      ],
      "answer": 0
    },
    {
      "question": "¿Cuál es una ventaja de la descentralización en las criptomonedas?",
      "options": [
        "Mayor riesgo de fraude por concentración de datos.",
        "Reducción de intermediarios y mayor seguridad en las transacciones.",
        "Control exclusivo de un banco central.",
        "Procesamiento de transacciones más lento."
      ],
      "answer": 1
    },
    {
      "question": "¿Qué tipo de token representa activos tangibles como bienes raíces o metales preciosos?",
      "options": [
        "Token de utilidad",
        "Token de seguridad",
        "Token de activos reales",
        "Token de gobernanza"
      ],
      "answer": 2
    },
    {
      "question": "¿Cuál es el primer paso recomendado para invertir en criptomonedas y tokens?",
      "options": [
        "Comprar cualquier token disponible en el mercado.",
        "Realizar un análisis exhaustivo del mercado y sus tendencias.",
        "Depositar todo el dinero en una sola criptomoneda.",
        "Evitar diversificar la cartera para maximizar ganancias."
      ],
      "answer": 1
    },
    {
      "question": "¿Qué función cumplen los nodos en una red blockchain?",
      "options": [
        "Controlar y centralizar la emisión de monedas.",
        "Validar, almacenar y mantener una copia completa del blockchain.",
        "Editar y modificar bloques antiguos libremente.",
        "Solo permitir transacciones internacionales."
      ],
      "answer": 1
    },
    {
      "question": "¿Cuál es una estrategia común para gestionar riesgos en inversión en criptomonedas?",
      "options": [
        "Invertir solo en la criptomoneda más volátil.",
        "Diversificar las inversiones entre diferentes criptomonedas y tokens.",
        "Mantener todas las inversiones en una sola plataforma de trading.",
        "Ignorar las noticias del mercado."
      ],
      "answer": 1
    },
  
    {
      "question": "¿Cuál fue uno de los principales problemas del trueque como sistema de intercambio?",
      "options": [
        "La dificultad para transportar grandes cantidades de bienes.",
        "La facilidad para asignar un valor común a los bienes intercambiados.",
        "La existencia de un medio universal de intercambio.",
        "El control centralizado de las transacciones."
      ],
      "answer": 0
    },
    {
      "question": "¿Cuál de los siguientes metales fue uno de los primeros en utilizarse como dinero?",
      "options": [
        "Hierro",
        "Oro",
        "Cobre",
        "Plomo"
      ],
      "answer": 2
    },
    {
      "question": "¿Qué función tenían las monedas acuñadas en las civilizaciones antiguas?",
      "options": [
        "Servir como un medio para almacenar grandes cantidades de oro.",
        "Facilitar el comercio estandarizando el valor y reforzar la autoridad del gobernante.",
        "Imprimir billetes para uso local.",
        "Crear un sistema bancario moderno."
      ],
      "answer": 1
    },
    {
      "question": "¿Qué caracteriza al dinero fiduciario?",
      "options": [
        "Está respaldado por metales preciosos almacenados en una caja fuerte.",
        "Su valor depende de la confianza en la entidad emisora y no de un valor intrínseco.",
        "Se basa en objetos de valor intrínseco como conchas o piedras preciosas.",
        "Es utilizado únicamente en sistemas de trueque."
      ],
      "answer": 1
    },
    {
      "question": "¿Cuál es una característica clave del dinero digital en la era moderna?",
      "options": [
        "Se utiliza exclusivamente en transacciones presenciales.",
        "Permite transacciones rápidas, seguras y convenientes mediante medios electrónicos.",
        "No requiere de ninguna forma de seguridad para su uso.",
        "Es emitido únicamente por bancos centrales físicos."
      ],
      "answer": 1
    },
  
    {
      "question": "¿Cuál es una característica clave de la tecnología blockchain?",
      "options": [
        "Centralización",
        "Privacidad",
        "Transparencia",
        "Anonimato absoluto"
      ],
      "answer": 2
    },
    {
      "question": "¿Qué es la tecnología blockchain?",
      "options": [
        "Una tecnología para transferir dinero de forma rápida y segura",
        "Una tecnología para almacenar y compartir datos de forma distribuida y segura",
        "Una tecnología para realizar transacciones en línea",
        "Un sistema centralizado para almacenar datos"
      ],
      "answer": 1
    },
    {
      "question": "¿Cuáles son algunos ejemplos de implementación de blockchain en la industria?",
      "options": [
        "Gestión de la cadena de suministro",
        "Redes sociales",
        "Transporte público",
        "Publicidad digital"
      ],
      "answer": 0
    },
    {
      "question": "¿Qué sectores industriales pueden beneficiarse de la implementación de blockchain?",
      "options": [
        "Sector energético",
        "Sector de la moda",
        "Sector alimentario",
        "Sector turístico"
      ],
      "answer": 0
    },
    {
      "question": "¿Cuál es uno de los principales desafíos de la implementación de blockchain en la industria?",
      "options": [
        "Facilidad de uso",
        "Escalabilidad y rendimiento",
        "Compatibilidad con teléfonos móviles antiguos",
        "Exceso de centralización"
      ],
      "answer": 1
    },
    {
      "question": "¿Qué es la descentralización en blockchain?",
      "options": [
        "Que una autoridad central controla la red",
        "Que todos los nodos tienen una copia completa y participan en la validación",
        "Que solo una computadora almacena la información",
        "Que las transacciones son anónimas sin control"
      ],
      "answer": 1
    },
    {
      "question": "¿Cuál es un ejemplo de caso de uso de blockchain en el sector financiero?",
      "options": [
        "Gestión de identidad",
        "Gestión de inventario",
        "Gestión de recursos humanos",
        "Publicidad en línea"
      ],
      "answer": 0
    },
    {
      "question": "¿Cómo puede blockchain mejorar la cadena de suministro?",
      "options": [
        "Ocultando el origen de los productos",
        "Proporcionando transparencia y rastreabilidad del producto",
        "Reduciendo el número de proveedores",
        "Centralizando la gestión en un solo ente"
      ],
      "answer": 1
    },
    {
      "question": "¿Qué oportunidad ofrece blockchain para la industria energética?",
      "options": [
        "Centralización del mercado energético",
        "Mercados energéticos descentralizados y peer-to-peer",
        "Reducir la producción de energía renovable",
        "Eliminar el uso de contratos inteligentes"
      ],
      "answer": 1
    },
    {
      "question": "¿Qué importancia tiene la colaboración en la implementación de blockchain en la industria?",
      "options": [
        "Permite intercambiar información y realizar transacciones sin intermediarios",
        "Impide la creación de alianzas entre empresas",
        "Limita el uso de blockchain a una sola empresa",
        "Reduce la seguridad de la red"
      ],
      "answer": 0
    },
    {
    "question": "¿Qué característica hace a blockchain especialmente útil en la cadena de suministro?",
    "options": [
      "Inmutabilidad de los registros",
      "Velocidad de transacción instantánea",
      "Bajo consumo energético"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es una de las aplicaciones más comunes de blockchain en el sector salud?",
    "options": [
      "Reducción de personal médico",
      "Historiales médicos electrónicos seguros",
      "Automatización de cirugías"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué ventaja aporta la descentralización de blockchain en la industria financiera?",
    "options": [
      "Eliminación de la necesidad de intermediarios",
      "Incremento de comisiones",
      "Procesos manuales más sencillos"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es un reto importante para la adopción de blockchain en empresas grandes?",
    "options": [
      "Demasiada regulación",
      "Escalabilidad de la red",
      "Falta de contratos inteligentes"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué propiedad de blockchain ayuda a combatir la falsificación de productos?",
    "options": [
      "Centralización",
      "Registro transparente e inmutable",
      "Privacidad absoluta"
    ],
    "answer": 1
  },
  {
    "question": "¿En qué sector puede usarse blockchain para certificados de energía renovable?",
    "options": [
      "Sector educativo",
      "Sector energético",
      "Sector transporte"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué función cumplen los contratos inteligentes en blockchain?",
    "options": [
      "Permiten ejecutar acuerdos automáticamente",
      "Aumentan la burocracia",
      "Almacenan información en papel"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál de las siguientes NO es una característica clave de blockchain?",
    "options": [
      "Descentralización",
      "Inmutabilidad",
      "Dependencia de un ente central"
    ],
    "answer": 2
  },
  {
    "question": "¿Qué permite la trazabilidad basada en blockchain en logística?",
    "options": [
      "Ocultar el origen de los productos",
      "Rastrear productos desde el origen hasta el destino",
      "Reducir el control de calidad"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué se busca mejorar con la interoperabilidad entre diferentes blockchains?",
    "options": [
      "Compatibilidad y comunicación entre redes",
      "Aumento del anonimato",
      "Reducción del número de usuarios"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál de los siguientes es un desafío de la implementación de blockchain?",
    "options": [
      "Escalabilidad",
      "Demasiados usuarios",
      "Exceso de velocidad"
    ],
    "answer": 0
  },
  {
    "question": "¿Cómo ayuda blockchain en la gestión de propiedad intelectual?",
    "options": [
      "Aumentando el plagio",
      "Creando registros verificables y automáticos",
      "Reduciendo la transparencia"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué sector puede beneficiarse de blockchain para mejorar la gestión de inventario?",
    "options": [
      "Logística y cadena de suministro",
      "Publicidad digital",
      "Educación básica"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es una oportunidad clave de usar blockchain en la industria?",
    "options": [
      "Automatización de procesos y reducción de costos",
      "Descentralización de la energía solar",
      "Aumento de errores humanos"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué significa que la información en blockchain sea inmutable?",
    "options": [
      "Puede modificarse bajo solicitud",
      "No puede alterarse una vez registrada",
      "Se elimina después de un año"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué tecnología subyace al funcionamiento de las criptomonedas?",
    "options": ["Inteligencia artificial", "Blockchain", "Internet de las cosas"],
    "answer": 1
  },
  {
    "question": "¿Cuál de las siguientes criptomonedas fue la primera en ser creada?",
    "options": ["Ethereum", "Bitcoin", "Ripple"],
    "answer": 1
  },
  {
    "question": "¿Qué característica diferencia a los tokens de las criptomonedas?",
    "options": [
      "Los tokens tienen su propia blockchain",
      "Los tokens se ejecutan sobre una blockchain existente",
      "Los tokens no son digitales"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué tipo de token da acceso a servicios dentro de una plataforma?",
    "options": ["Token de seguridad", "Token de utilidad", "Token de activos reales"],
    "answer": 1
  },
  {
    "question": "¿Qué característica permite que una transacción en blockchain no pueda ser modificada?",
    "options": ["Privacidad", "Inmutabilidad", "Interoperabilidad"],
    "answer": 1
  },
  {
    "question": "¿Qué es un contrato inteligente?",
    "options": [
      "Un tipo de criptomoneda",
      "Un documento legal",
      "Un programa que ejecuta acuerdos automáticamente en blockchain"
    ],
    "answer": 2
  },
  {
    "question": "¿Cuál es una ventaja clave de las criptomonedas en comparación con las monedas tradicionales?",
    "options": [
      "Mayor control gubernamental",
      "Transacciones rápidas y globales",
      "Requieren intermediarios bancarios"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué representa un token respaldado por bienes raíces?",
    "options": ["Token de utilidad", "Token no fungible", "Token de activos reales"],
    "answer": 2
  },
  {
    "question": "¿Cuál es una función del análisis técnico en el trading de criptomonedas?",
    "options": [
      "Predecir patrones de precios",
      "Auditar contratos inteligentes",
      "Crear nuevas criptomonedas"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué plataforma es comúnmente usada para crear tokens mediante contratos inteligentes?",
    "options": ["Bitcoin", "Ethereum", "Ripple"],
    "answer": 1
  },
  {
    "question": "¿Cuál es uno de los riesgos de invertir en criptomonedas?",
    "options": ["Volatilidad del mercado", "Exceso de regulación", "Inversión garantizada"],
    "answer": 0
  },
  {
    "question": "¿Qué herramienta se usa para almacenar criptomonedas de forma segura?",
    "options": ["Wallet o cartera digital", "Token", "Smart contract"],
    "answer": 0
  },
  {
    "question": "¿Qué diferencia a un token de seguridad de uno de utilidad?",
    "options": [
      "El de seguridad representa un activo financiero",
      "El de utilidad se regula como acción",
      "El de seguridad se usa solo en videojuegos"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué acción describe el trading diario?",
    "options": [
      "Mantener criptomonedas durante años",
      "Comprar y vender en cortos plazos, incluso dentro del mismo día",
      "Invertir solo en tokens respaldados por oro"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué ventaja ofrece la descentralización en el uso de blockchain?",
    "options": [
      "Menor acceso público",
      "Mayor dependencia de intermediarios",
      "Eliminación de control por una sola entidad"
    ],
    "answer": 2
  },
  {
    "question": "¿Qué es una función hash?",
    "options": [
      "Un algoritmo que encripta datos con una clave secreta",
      "Un algoritmo que convierte datos en una secuencia fija de caracteres",
      "Una clave pública en blockchain"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué característica tiene una función hash como SHA-256?",
    "options": [
      "Es reversible",
      "Devuelve siempre una salida de la misma longitud",
      "Genera claves privadas"
    ],
    "answer": 1
  },
  {
    "question": "¿Para qué se utiliza SHA-256 en blockchain?",
    "options": [
      "Firmar contratos inteligentes",
      "Verificar integridad de datos y bloques",
      "Almacenar direcciones IP"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué sucede si se cambia un solo carácter en los datos originales antes de aplicar SHA-256?",
    "options": [
      "La salida cambia completamente",
      "El hash permanece igual",
      "La transacción se invalida automáticamente"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es la salida de SHA-256?",
    "options": [
      "256 dígitos",
      "256 caracteres",
      "256 bits"
    ],
    "answer": 2
  },
  {
    "question": "¿Qué es un exchange centralizado (CEX)?",
    "options": [
      "Una plataforma controlada por una empresa donde se intercambian criptoactivos",
      "Un mercado descentralizado en Web3",
      "Un nodo verificador"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es un exchange descentralizado (DEX)?",
    "options": [
      "Una casa de cambio oficial del gobierno",
      "Una plataforma sin intermediarios para el intercambio de tokens",
      "Un sistema bancario de blockchain"
    ],
    "answer": 1
  },
  {
    "question": "¿Cuál es una ventaja de los DEX sobre los CEX?",
    "options": [
      "Mayor control del usuario sobre sus fondos",
      "Mayor regulación",
      "Menores tarifas bancarias"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es un puente (bridge) en blockchain?",
    "options": [
      "Un contrato inteligente especializado en NFTs",
      "Un sistema para conectar dos blockchains distintas",
      "Una billetera digital"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué riesgo tienen los puentes entre blockchains?",
    "options": [
      "Pueden duplicar tokens",
      "Son vulnerables a ataques si no están bien auditados",
      "Pierden compatibilidad con Ethereum"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es una ICO?",
    "options": [
      "Una venta anticipada de tokens para recaudar fondos",
      "Un tipo de contrato inteligente",
      "Un sistema de validación de bloques"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué se obtiene al participar en una ICO?",
    "options": [
      "Tokens de una futura plataforma o proyecto",
      "Acciones legales de la empresa",
      "Un préstamo a la red blockchain"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es un NFT?",
    "options": [
      "Un token que representa un activo único",
      "Un archivo comprimido",
      "Una criptomoneda de código abierto"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué estándar usa Ethereum para la mayoría de los NFTs?",
    "options": [
      "ERC-20",
      "ERC-721",
      "ERC-1155"
    ],
    "answer": 1
  },
  {
    "question": "¿Cuál es la diferencia entre ERC-20 y ERC-721?",
    "options": [
      "ERC-20 es para tokens fungibles, ERC-721 para no fungibles",
      "ERC-721 es más rápido",
      "ERC-20 se usa solo en NFTs"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué representa un token fungible?",
    "options": [
      "Un activo único",
      "Un activo que puede intercambiarse por otro de igual valor",
      "Un contrato con un usuario"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es un token de gobernanza?",
    "options": [
      "Un NFT para votar",
      "Un token que otorga derecho a participar en decisiones de una DAO",
      "Un token usado solo en CEX"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es una DAO?",
    "options": [
      "Una red de mineros",
      "Una organización descentralizada gobernada por código",
      "Una nueva criptomoneda"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es una blockchain?",
    "options": [
      "Una base de datos centralizada",
      "Una red de servidores web",
      "Un libro de contabilidad distribuido e inmutable"
    ],
    "answer": 2
  },
  {
    "question": "¿Qué es un nodo en blockchain?",
    "options": [
      "Un usuario que navega en internet",
      "Una computadora que participa en la red blockchain",
      "Un contrato inteligente"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué hace un nodo validador?",
    "options": [
      "Envía correos automáticos",
      "Firma las transacciones y las incluye en bloques",
      "Crea nuevas monedas"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es una wallet en cripto?",
    "options": [
      "Un banco descentralizado",
      "Un sitio para crear NFTs",
      "Una herramienta para almacenar claves privadas y tokens"
    ],
    "answer": 2
  },
  {
    "question": "¿Cuál es una ventaja de usar una wallet de hardware?",
    "options": [
      "Se conecta a cualquier red social",
      "Permite almacenar claves fuera de línea",
      "Es gratuita y anónima"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué protocolo permite crear múltiples tipos de tokens en un solo contrato?",
    "options": [
      "ERC-20",
      "ERC-721",
      "ERC-1155"
    ],
    "answer": 2
  },
  {
    "question": "¿Qué indica el término 'tokenización'?",
    "options": [
      "La conversión de activos reales en representaciones digitales en blockchain",
      "El envío de criptomonedas a otro usuario",
      "El minado de nuevos tokens"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es el objetivo de los contratos inteligentes?",
    "options": [
      "Mejorar la conexión a internet",
      "Ejecutar acciones automáticamente bajo condiciones acordadas",
      "Crear nodos mineros"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué significa DApp?",
    "options": [
      "Aplicación de minería",
      "Aplicación centralizada de datos",
      "Aplicación descentralizada"
    ],
    "answer": 2
  },
  {
    "question": "¿Qué permite hacer un puente (bridge)?",
    "options": [
      "Convertir tokens entre diferentes blockchains",
      "Aumentar la velocidad de la red",
      "Desplegar contratos desde una wallet"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué representa un whitepaper en una ICO?",
    "options": [
      "Un plan técnico y económico del proyecto",
      "Una herramienta de trading",
      "Un certificado digital"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué tipo de inversión es común en ICOs?",
    "options": [
      "Intercambio de criptomonedas por tokens del proyecto",
      "Compra de acciones en bolsa",
      "Depósitos bancarios"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es un 'hash' en una transacción?",
    "options": [
      "Un identificador único de la transacción",
      "Un contrato firmado",
      "Un número aleatorio de nodos"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué representa un bloque en blockchain?",
    "options": [
      "Un archivo de video",
      "Una colección de transacciones validadas",
      "Un usuario específico"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué protocolo es el estándar para tokens fungibles en Ethereum?",
    "options": [
      "ERC-20",
      "ERC-721",
      "ERC-404"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué caracteriza a los NFTs?",
    "options": [
      "Son intercambiables entre sí",
      "Representan activos únicos",
      "Solo existen en Bitcoin"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué significa interoperabilidad entre blockchains?",
    "options": [
      "Conectividad y transferencia entre diferentes redes",
      "Duplicación de tokens",
      "Auditoría legal"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es el objetivo principal de los bridges?",
    "options": [
      "Reducir comisiones de red",
      "Transferir activos entre blockchains",
      "Crear wallets nuevas"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es una red de prueba (testnet)?",
    "options": [
      "Una blockchain usada para probar sin riesgo real",
      "Un sitio web de minería",
      "Un contrato de staking"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es un explorador de bloques?",
    "options": [
      "Un navegador para la web",
      "Una herramienta para visualizar transacciones y bloques",
      "Una wallet multicadena"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué hace un oráculo en blockchain?",
    "options": [
      "Actúa como fuente externa de datos para contratos inteligentes",
      "Crea NFTs automáticamente",
      "Controla nodos"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué representa la descentralización?",
    "options": [
      "Control en manos de una autoridad única",
      "Participación de múltiples nodos sin jerarquía central",
      "Blockchain en una sola computadora"
    ],
    "answer": 1
  },
  {
    "question": "¿Cuál es la diferencia entre criptomoneda y token?",
    "options": [
      "Los tokens no están en blockchain",
      "Las criptomonedas tienen blockchain propia, los tokens no",
      "Los tokens no pueden usarse como dinero"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué representa un nodo completo?",
    "options": [
      "Un nodo que guarda toda la blockchain y valida bloques",
      "Un nodo de minería",
      "Una wallet en línea"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es el 'gas' en Ethereum?",
    "options": [
      "Un token de gobernanza",
      "La tarifa para ejecutar operaciones",
      "Una unidad de almacenamiento de NFTs"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué permite una red Layer 2?",
    "options": [
      "Mayor escalabilidad sobre una blockchain principal",
      "Crear una nueva criptomoneda",
      "Reducir la seguridad de la red"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es la minería de criptomonedas?",
    "options": [
      "El proceso de diseñar contratos inteligentes",
      "El proceso de validar transacciones y añadir bloques a la blockchain",
      "La creación de billeteras digitales"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué recurso consumen los mineros para realizar su trabajo?",
    "options": [
      "Gas natural",
      "Poder computacional y electricidad",
      "Tarjetas de fidelidad"
    ],
    "answer": 1
  },
  {
    "question": "¿Cuál es la recompensa de un minero en una red como Bitcoin?",
    "options": [
      "Nuevos tokens emitidos y tarifas por transacción",
      "NFTs",
      "Tokens de gobernanza"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es un contrato inteligente (smart contract)?",
    "options": [
      "Un contrato legal tradicional",
      "Un código que se ejecuta automáticamente en blockchain",
      "Un documento PDF firmado digitalmente"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué blockchain es conocida por popularizar los contratos inteligentes?",
    "options": ["Bitcoin", "Ethereum", "Ripple"],
    "answer": 1
  },
  {
    "question": "¿Qué lenguaje se usa comúnmente para escribir contratos inteligentes en Ethereum?",
    "options": ["Rust", "Solidity", "Python"],
    "answer": 1
  },
  {
    "question": "¿Qué es DeFi (finanzas descentralizadas)?",
    "options": [
      "Un sistema financiero regulado por bancos centrales",
      "Un sistema financiero sin intermediarios que corre en blockchain",
      "Una nueva moneda estable"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué puedes hacer en una plataforma DeFi?",
    "options": [
      "Pedir préstamos, hacer staking o intercambiar tokens",
      "Comprar tarjetas de crédito físicas",
      "Minar oro"
    ],
    "answer": 0
  },
  {
    "question": "¿Cuál es una ventaja clave de DeFi?",
    "options": [
      "Alta intermediación",
      "Acceso global sin bancos tradicionales",
      "Tarifas altas y fijas"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es un protocolo de lending en DeFi?",
    "options": [
      "Una empresa bancaria centralizada",
      "Un sistema que permite prestar o pedir criptoactivos con garantía",
      "Un puente entre redes"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué representa el término 'staking'?",
    "options": [
      "Gastar criptomonedas",
      "Bloquear tokens para obtener recompensas o validar transacciones",
      "Cambiar tokens a monedas fiat"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué diferencia a FinTech del sistema financiero tradicional?",
    "options": [
      "FinTech usa tecnología digital para ofrecer servicios financieros",
      "FinTech no usa ninguna tecnología",
      "FinTech solo funciona con efectivo"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué es una wallet custodial?",
    "options": [
      "Una wallet controlada por el usuario",
      "Una wallet donde un tercero controla las llaves privadas",
      "Una wallet usada solo en exchanges descentralizados"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué función tiene un oráculo en un contrato inteligente?",
    "options": [
      "Crear bloques",
      "Traer datos del mundo real a la blockchain",
      "Enviar correos electrónicos"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué es un AMM (Automated Market Maker)?",
    "options": [
      "Una wallet especializada",
      "Un algoritmo que permite intercambiar tokens sin libro de órdenes",
      "Un tipo de token no fungible"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué representa una stablecoin?",
    "options": [
      "Una criptomoneda sin valor",
      "Un token con precio vinculado a un activo estable, como el dólar",
      "Un token que solo existe en testnets"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué significa yield farming?",
    "options": [
      "Una técnica para aumentar el rendimiento en DeFi colocando fondos estratégicamente",
      "El cultivo de criptomonedas",
      "Una técnica de minería en Proof of Work"
    ],
    "answer": 0
  },
  {
    "question": "¿Qué plataforma es conocida por ofrecer servicios de préstamos descentralizados?",
    "options": ["Uniswap", "Aave", "MetaMask"],
    "answer": 1
  },
  {
    "question": "¿Cuál es una amenaza común en contratos inteligentes mal escritos?",
    "options": [
      "Errores en la cadena de bloques",
      "Exploits o ataques que roban fondos",
      "Pérdida de NFTs"
    ],
    "answer": 1
  },
  {
    "question": "¿Qué hace un auditor de contratos inteligentes?",
    "options": [
      "Genera tokens",
      "Revisa el código para detectar vulnerabilidades",
      "Valida bloques en Bitcoin"
    ],
    "answer": 1
  },
  {
    id: "crypto-mcq-1",
    type: "mcq",
    question: "¿Qué son las criptomonedas?",
    options: [
      "Dinero físico emitido por bancos centrales",
      "Dinero digital descentralizado protegido con criptografía",
      "Un tipo de correo electrónico seguro",
      "Una acción bursátil de empresas tecnológicas"
    ],
    answer: 1,
    explanation: "Son activos digitales que usan criptografía y una red descentralizada para operar sin intermediarios."
  },
  {
    id: "crypto-mcq-2",
    type: "mcq",
    question: "¿Qué característica describe mejor a una blockchain pública?",
    options: [
      "Solo la empresa dueña puede leer y escribir datos",
      "Cualquiera puede participar y verificar el registro según las reglas del protocolo",
      "Los datos se guardan en un solo servidor central",
      "Las transacciones se pueden editar libremente después"
    ],
    answer: 1,
    explanation: "En una blockchain pública, cualquier persona puede verificar y, según el protocolo, participar."
  },
  {
    id: "crypto-mcq-3",
    type: "mcq",
    question: "¿Qué significa que una blockchain sea inmutable?",
    options: [
      "Que no se puede copiar",
      "Que los bloques se pueden borrar cuando se quiera",
      "Que una vez confirmados, los datos son muy difíciles de alterar",
      "Que no usa criptografía"
    ],
    answer: 2,
    explanation: "La inmutabilidad se refiere a la dificultad práctica de cambiar datos ya confirmados."
  },
  {
    id: "crypto-mcq-4",
    type: "mcq",
    question: "¿Qué es una clave privada (private key)?",
    options: [
      "Un nombre de usuario público",
      "Un código secreto que permite firmar transacciones y controlar fondos",
      "Una contraseña que el exchange te manda por correo",
      "El identificador de un bloque"
    ],
    answer: 1,
    explanation: "La clave privada firma transacciones; quien la controla, controla los fondos."
  },
  {
    id: "crypto-mcq-5",
    type: "mcq",
    question: "¿Para qué sirve una wallet (cartera) en criptomonedas?",
    options: [
      "Para guardar monedas físicas",
      "Para almacenar y gestionar claves que permiten controlar activos en la blockchain",
      "Para minar automáticamente desde el celular",
      "Para cambiar el precio de un token"
    ],
    answer: 1,
    explanation: "Las wallets gestionan claves (no ‘guardan’ monedas físicamente), y permiten firmar transacciones."
  },
  {
    id: "crypto-mcq-6",
    type: "mcq",
    question: "¿Qué es una stablecoin?",
    options: [
      "Una moneda que siempre sube de precio",
      "Una criptomoneda diseñada para mantener un valor estable (por ejemplo, cerca de 1 USD)",
      "Un token solo para memes",
      "Un tipo de NFT"
    ],
    answer: 1,
    explanation: "Las stablecoins buscan estabilidad de precio usando colateral, algoritmos o reservas."
  },
  {
    id: "crypto-mcq-7",
    type: "mcq",
    question: "¿Qué es el gas (fee) en redes como Ethereum o Polygon?",
    options: [
      "Un impuesto del gobierno",
      "Un costo para ejecutar transacciones y operaciones en la red",
      "Un token que solo existe en Bitcoin",
      "Una comisión obligatoria del banco"
    ],
    answer: 1,
    explanation: "El gas paga a validadores/mineros por procesar transacciones y computación."
  },
  {
    id: "crypto-mcq-8",
    type: "mcq",
    question: "¿Qué es un smart contract?",
    options: [
      "Un contrato en PDF firmado por correo",
      "Código que se ejecuta en una blockchain y cumple reglas automáticamente",
      "Una app móvil de un exchange",
      "Un documento legal que solo existe fuera de blockchain"
    ],
    answer: 1,
    explanation: "Son programas en blockchain que ejecutan condiciones y reglas sin intermediarios."
  },
  {
    id: "crypto-mcq-9",
    type: "mcq",
    question: "¿Qué significa 'not your keys, not your coins'?",
    options: [
      "Que si no tienes tu clave privada, no tienes control real de tus fondos",
      "Que las llaves de la casa son importantes",
      "Que necesitas dos contraseñas para entrar a un exchange",
      "Que Bitcoin no usa claves"
    ],
    answer: 0,
    explanation: "Si un tercero controla tus llaves (exchange), él controla el acceso a tus activos."
  },
  {
    id: "crypto-mcq-10",
    type: "mcq",
    question: "¿Qué es un exchange centralizado (CEX)?",
    options: [
      "Una plataforma administrada por una empresa que facilita compra/venta y custodia",
      "Un contrato inteligente sin empresa",
      "Una blockchain privada de gobierno",
      "Un tipo de stablecoin"
    ],
    answer: 0,
    explanation: "Un CEX es una empresa que intermedia operaciones y frecuentemente custodia fondos."
  },

  // =========================
  // 10 DRAG_BLANKS (Arrastrar)
  // =========================
  {
    id: "crypto-drag-1",
    type: "drag_blanks",
    title: "Completa arrastrando los conceptos básicos de blockchain.",
    options: ["bloque", "hash", "cadena", "inmutable", "distribuida", "nodos"],
    items: [
      {
        textParts: ["Una blockchain es una ", " de ", " donde participan muchos ", "."],
        answers: ["cadena", "bloque", "nodos"]
      },
      {
        textParts: ["Cada bloque se identifica con un ", " que depende de su contenido."],
        answers: ["hash"]
      },
      {
        textParts: ["Cuando los datos se confirman, el registro se vuelve muy difícil de cambiar: es ", "."],
        answers: ["inmutable"]
      },
      {
        textParts: ["La información no está en un solo lugar; está ", " en varios participantes."],
        answers: ["distribuida"]
      }
    ]
  },
  {
    id: "crypto-drag-2",
    type: "drag_blanks",
    title: "Completa: Wallets y claves",
    options: ["clave privada", "firmar", "transacción", "clave pública", "control"],
    items: [
      {
        textParts: ["La ", " te da ", " sobre tus fondos."],
        answers: ["clave privada", "control"]
      },
      {
        textParts: ["Para enviar fondos necesitas ", " una ", "."],
        answers: ["firmar", "transacción"]
      },
      {
        textParts: ["La ", " se puede compartir; la privada no."],
        answers: ["clave pública"]
      }
    ]
  },
  {
    id: "crypto-drag-3",
    type: "drag_blanks",
    title: "Completa: Tipos de criptomonedas",
    options: ["Bitcoin", "altcoin", "stablecoin", "meme coin", "volatilidad"],
    items: [
      {
        textParts: ["", " fue la primera criptomoneda y es la más conocida."],
        answers: ["Bitcoin"]
      },
      {
        textParts: ["Una ", " es cualquier criptomoneda distinta de Bitcoin."],
        answers: ["altcoin"]
      },
      {
        textParts: ["Una ", " busca mantener un precio estable (por ejemplo, cerca de 1 USD)."],
        answers: ["stablecoin"]
      },
      {
        textParts: ["Una ", " suele depender mucho de comunidad y tendencia; puede tener alta ", "."],
        answers: ["meme coin", "volatilidad"]
      }
    ]
  },
  {
    id: "crypto-drag-4",
    type: "drag_blanks",
    title: "Completa: Fees (gas) y red",
    options: ["gas", "validadores", "transacciones", "comisiones", "procesar"],
    items: [
      {
        textParts: ["El ", " es el costo de ", " operaciones en la red."],
        answers: ["gas", "procesar"]
      },
      {
        textParts: ["Estas ", " ayudan a pagar a los ", " por incluir ", "."],
        answers: ["comisiones", "validadores", "transacciones"]
      }
    ]
  },
  {
    id: "crypto-drag-5",
    type: "drag_blanks",
    title: "Completa: Seguridad",
    options: ["phishing", "seed phrase", "2FA", "respaldo", "compartir"],
    items: [
      {
        textParts: ["La ", " (frase semilla) sirve como ", " de tu wallet."],
        answers: ["seed phrase", "respaldo"]
      },
      {
        textParts: ["Nunca debes ", " tu frase semilla con nadie."],
        answers: ["compartir"]
      },
      {
        textParts: ["Activa ", " y evita enlaces de ", "."],
        answers: ["2FA", "phishing"]
      }
    ]
  },
  {
    id: "crypto-drag-6",
    type: "drag_blanks",
    title: "Completa: Exchanges",
    options: ["CEX", "DEX", "custodia", "empresa", "smart contracts"],
    items: [
      {
        textParts: ["Un ", " es un exchange operado por una ", " y normalmente ofrece ", " de fondos."],
        answers: ["CEX", "empresa", "custodia"]
      },
      {
        textParts: ["Un ", " opera con ", " y suele ser sin custodia."],
        answers: ["DEX", "smart contracts"]
      }
    ]
  },
  {
    id: "crypto-drag-7",
    type: "drag_blanks",
    title: "Completa: Tokens y monedas nativas",
    options: ["moneda nativa", "pagar fees", "token", "red", "contrato"],
    items: [
      {
        textParts: ["La ", " se usa en la ", " para ", "."],
        answers: ["moneda nativa", "red", "pagar fees"]
      },
      {
        textParts: ["Un ", " normalmente existe en un ", " inteligente."],
        answers: ["token", "contrato"]
      }
    ]
  },
  {
    id: "crypto-drag-8",
    type: "drag_blanks",
    title: "Completa: Consenso",
    options: ["consenso", "PoW", "PoS", "validar", "bloques"],
    items: [
      {
        textParts: ["El ", " permite que la red acuerde qué ", " son correctos."],
        answers: ["consenso", "bloques"]
      },
      {
        textParts: ["En ", " se usa trabajo computacional; en ", " se usa participación (stake)."],
        answers: ["PoW", "PoS"]
      },
      {
        textParts: ["Los participantes ayudan a ", " transacciones y bloques según las reglas."],
        answers: ["validar"]
      }
    ]
  },
  {
    id: "crypto-drag-9",
    type: "drag_blanks",
    title: "Completa: NFT",
    options: ["NFT", "único", "propiedad", "coleccionable", "blockchain"],
    items: [
      {
        textParts: ["Un ", " es un activo digital ", " en una ", "."],
        answers: ["NFT", "único", "blockchain"]
      },
      {
        textParts: ["Suele usarse para demostrar ", " de un objeto digital o ", "."],
        answers: ["propiedad", "coleccionable"]
      }
    ]
  },
  {
    id: "crypto-drag-10",
    type: "drag_blanks",
    title: "Completa: Direcciones",
    options: ["dirección", "wallet", "recibir", "enviar", "pública"],
    items: [
      {
        textParts: ["Una ", " es un identificador ", " que se usa para ", " fondos."],
        answers: ["dirección", "pública", "recibir"]
      },
      {
        textParts: ["Desde tu ", " también puedes ", " fondos firmando con tu clave privada."],
        answers: ["wallet", "enviar"]
      }
    ]
  }
  ]
  